export default __webpack_public_path__ + "static/media/icon-photo.00032c6f.svg";